
import AdvSelect from '@/components/adv-select/AdvSelect.vue'
import { uploadToMedia } from '@/api/local-material'
import { getPushSourceAdvertisers } from '@/api/open'

export default {
    components: {
        AdvSelect
    },
    props: {
        showUploadForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    data () {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            loading: false,
            sourceAdvertisers: [],
            sourceAdvertiserId: null,
            advertiserMode: 'single', // 'single' 单广告主 | 'multi' 多广告主
            rules: {
                advertiser_id: [ { required: true, message: '请输入广告主ID', trigger: 'change' }],
            },
            title: '同步视频到媒体',
        }
    },
    created () {
        if (this.model.up_type === 2 || this.model.up_type === 3) {
            this.title = '推送视频到媒体'
        } else if (this.model.up_type === 4) {
            // up_type=4：快手专属，走"代理商平台-广告主后台-上传视频"，来源显示为"本地上传"
            this.title = '同步到快手（本地上传）'
        }
    },
    computed: {},
    mounted () {
        if (this.model.up_type === 2 && (this.model.media === 1 || this.model.media === 2)) {
            this.fetchSourceAdvertisers()
        }
    },
    methods: {
        onAdvertiserModeChange(key) {
            this.advertiserMode = key
            // 切换时清空广告主选择
            this.model.advertiser_id = key === 'single' ? null : []
        },
        fetchSourceAdvertisers() {
            const ids = this.model.local_material_ids || []
            if (ids.length === 0) return
            getPushSourceAdvertisers({ local_material_ids: ids, media: this.model.media }).then(res => {
                if (res && res.code === 0 && res.data) {
                    this.sourceAdvertisers = res.data.list || []
                    if (this.sourceAdvertisers.length === 1) {
                        this.sourceAdvertiserId = this.sourceAdvertisers[0].advertiser_id
                    }
                }
            }).catch(() => {})
        },
        submit() {
            if (this.model.up_type === 2 && (this.model.media === 1 || this.model.media === 2) && !this.sourceAdvertiserId) {
                this.$message.error('请选择来源广告主')
                return
            }
            if (this.advertiserMode === 'multi' && (!this.model.advertiser_id || this.model.advertiser_id.length === 0)) {
                this.$message.error('请选择广告主')
                return
            }
            console.log({local_material_id:this.model.id, advertiser_id: this.model.advertiser_id})
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            });
        },
        storeOrUpdate() {
            this.loading = true
            
            uploadToMedia({local_material_id:this.model.id,local_material_ids:this.model.local_material_ids,advertiser_id: this.model.advertiser_id, up_type:this.model.up_type ?? 1, material_id: this.model.material_id ?? null, material_advertiser_id: this.model.material_advertiser_id ?? null, media: this.model.media, source_advertiser_id: this.sourceAdvertiserId}).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    let message = ''
                    if (this.model.up_type === 2 || this.model.up_type === 3) {
                        message = '推送成功！'
                    } else {
                        message = '提交任务成功，请等待！'
                    }
                    this.$message.success(message)
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.model.advertiser_id = null
            this.sourceAdvertiserId = null
            this.sourceAdvertisers = []
            this.advertiserMode = 'single'
            this.$emit('update:showUploadForm', false)
            this.$emit('success')
        },
    }
}
